export default "__VITE_ASSET__DrWiQV80__"